import { render, staticRenderFns } from "./AdminHistoryList.vue?vue&type=template&id=94595876&scoped=true&"
import script from "./AdminHistoryList.vue?vue&type=script&lang=js&"
export * from "./AdminHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./AdminHistoryList.vue?vue&type=style&index=0&id=94595876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94595876",
  null
  
)

export default component.exports